// removed by extract-text-webpack-plugin
module.exports = {"validation-text":"_3Eti","rex_campaign_btn":"_26Ln"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App.scss
// module id = 66
// module chunks = 0